/* eslint-disable react/require-default-props */
import * as React from 'react';
import { ReactNode } from 'react';

import Dashboard from './Dashboard';
import CourseLibrary from './CourseLibrary';
import VideoLibrary from './VideoLibrary';
import MyElearning from './MyElearning';
import Copy from './Copy';
import AiSparkle from './AiSparkle';
import ImageOutline from './ImageOutline';

export interface IconPropsType {
  /** The content of a icon */
  children?: ReactNode | string;
  /** Add custom class to class attribute */
  className?: string;
  /** Icon title */
  title?: string;
  /** Icon size: 'xs' (12px) | 'sm' (18px) | 'md' (24px) */
  size?: 'xs' | 'sm' | 'md';
}

const Icon = ({ children, title, className, size }: IconPropsType) => {
  const sizeClass = size ? `elmo-icon--size-${size}` : '';
  return (
    <span
      data-testid="elmo-icon"
      title={title}
      className={['elmo-icon', sizeClass, className].filter(Boolean).join(' ')}
    >
      <svg
        focusable="false"
        viewBox="0 0 24 24"
        aria-hidden="true"
        role="presentation"
        className="elmo-icon__svg"
      >
        {children}
      </svg>
    </span>
  );
};

export function withIcon(iconComponent: any) {
  const IconComponent = ({ title, className, size }: any) => (
    <Icon
      title={title}
      className={['custom-icon', className].filter(Boolean).join(' ')}
      size={size}
    >
      {React.cloneElement(iconComponent as React.ReactElement<any>, {})}
    </Icon>
  );

  return IconComponent;
}

export default Icon;

export const DashboardIcon = withIcon(<Dashboard />);
export const MyElearningIcon = withIcon(<MyElearning />);
export const CourseLibraryIcon = withIcon(<CourseLibrary />);
export const VideoLibraryIcon = withIcon(<VideoLibrary />);

export const CopyIcon = withIcon(<Copy />);
export const AiSparkleIcon = withIcon(<AiSparkle />);
export const ImageOutlineIcon = withIcon(<ImageOutline />);
